import { render, staticRenderFns } from "./DialogContainer.vue?vue&type=template&id=6b76b977&scoped=true"
var script = {}
import style0 from "./DialogContainer.vue?vue&type=style&index=0&id=6b76b977&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b76b977",
  null
  
)

export default component.exports